import { Star } from "lucide-react";

export default function StarRating({ value = 0, count = 0, size = 14, showEmpty = true, className = "", testid }) {
  const rounded = Math.round((value || 0) * 2) / 2;
  const stars = [1, 2, 3, 4, 5];
  if ((!value || value === 0) && !showEmpty) return null;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-0.5 ${className}`}>
      {stars.map((s) => {
        const filled = rounded >= s;
        return (
          <Star
            key={s}
            style={{ width: size, height: size }}
            className={filled ? "text-amber-500 fill-amber-500" : "text-neutral-700"}
            strokeWidth={2}
          />
        );
      })}
      {count > 0 && (
        <span className="ml-1 text-xs text-neutral-400 uppercase tracking-wide">
          {value?.toFixed(1)} ({count})
        </span>
      )}
      {count === 0 && showEmpty && (
        <span className="ml-1 text-[10px] text-neutral-500 uppercase tracking-widest">No reviews yet</span>
      )}
    </span>
  );
}
